import { PersonLookupRequestInterface } from '../models/person-lookup-api.interface';

export const LOYALTY_LOOKUP_PARAMS: PersonLookupRequestInterface['ExtraLookupParams'] =
  {
    IncludeAttributes: true,
    IncludePhoneNumbers: true,
    IncludeLoyaltyLevels: true,
    IncludeMemberships: true,
  };
